import { JsonConvert } from 'json2typescript';
const jsonConvert: JsonConvert = new JsonConvert();


/**
 * jsonオブジェクトをEntitiyクラスに変換する。
 * @param json jsonオブジェクトを指定(json文字列ではない)。
 * @param entityClass 変換したいentityClassを指定。
 */
export const deserializeObject = async <T>(json: any, entityClass: any) => new Promise<T>((resolve, reject) => {
  try {
    const entityParsed = jsonConvert.deserializeObject<T>(json, entityClass)
    return resolve(entityParsed)
  } catch (e) {
    console.log(e)
    return reject(e)
  }
})

/**
 * jsonオブジェクトをEntitiyクラスのArrayに変換する。
 * @param json jsonオブジェクトを指定(json文字列ではない)。
 * @param entityClass 変換したいentityClassを指定。
 */
export const deserializeArray = async <T>(json: any, entityClass: any) => new Promise<T[]>((resolve, reject) => {
  try {
    const entityParsed = jsonConvert.deserializeArray<T>(json, entityClass)
    return resolve(entityParsed)
  } catch (e) {
    console.log(e)
    return reject(e)
  }
})

/**
 * jsonオブジェクトをEntitiyクラスかEntityクラスのArrayに変換する。
 * @param json jsonオブジェクトを指定(json文字列ではない)。Arrayであれば、自動的に戻り値もArrayになる
 * @param entityClass 変換したいentityClassを指定。
 */
export const deserialize = async <T>(json: any, entityClass: any) => new Promise<T | T[]>((resolve, reject) => {
  try {
        // The methods serialize() and deserialize() will automatically detect the dimension of your param (either object or array).
    const entityParsed = jsonConvert.deserialize<T>(json, entityClass)
    return resolve(entityParsed)
  } catch (e) {
    console.log(e)
    return reject(e)
  }
})

/**
 * EntitiyクラスオブジェクトかEntityクラスのArrayをjsonオブジェクトに変換する
 * @param object オブジェクトを指定
 */
export const serialize = <T>(object: any) => {
  return jsonConvert.serialize<T>(object)
}
